import { buyOffer as f } from "../../../pages/checkout/api/index.mjs";
const a = (r, o) => f(r, o);
export {
  a as mercadoPagoCardBuyOffer
};
